<template>
  <div
    :class="['flag', `flag--${flagTheme}`]"
  >
    <span :aria-label="text">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: 'FlagComponent',
  props: {
    text: {
      type: String,
      required: false,
      default: '',
    },
    theme: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    flagTheme() {
      const availableThemes = ['light', 'brand', 'sale', 'sale-dark'];

      return availableThemes.includes(this.theme) ? this.theme : 'light';
    },
  },
};
</script>
<style lang="scss">

  .flag {
    @include cdr-text-utility-sans-strong-200;
    display: inline-block;
    text-transform: uppercase;
    letter-spacing: 1.92px;
    font-size: 0.7rem;
    line-height: 1;
    position: relative;

    @include cdr-sm-mq-up {
      font-size: 1rem;
    }

    @include cdr-md-mq-up {
      font-size: $cdr-text-utility-sans-strong-200-size;
    }

    span {
      padding: 6px 6px 5px;
      display: block;
      position: relative;
      z-index: 1;

      @include cdr-sm-mq-up {
        font-size: 1rem;
        padding: 9px 16px 8px;
      }

      @include cdr-md-mq-up {
        padding: 9px 10px 8px;
      }
    }

    span,
    &:after {
      border-radius: 0 2px 2px 0;
    }

    &:after {
      content: '';
      display: block;
      position: absolute;
      top: 3px;
      left: 0;
      right: 1px;
      bottom: -1px;

      @include cdr-sm-mq-up {
        bottom: -2px;
      }

      @include cdr-md-mq-up {
        bottom: -3px;
      }
    }

    &--light {
      color: $cdr-color-text-primary;

      span {
        background-color: $cdr-color-background-primary;
      }

      &:after {
        background-color: $cdr-color-background-brand-spruce;
      }
    }

    &--brand {
      color: $cdr-color-text-inverse;

      span {
        background-color: $cdr-color-background-brand-spruce;
      }

      &:after {
        background-color: #ACB4A2;
      }
    }

    &--sale {
      color: $cdr-color-text-sale;

      span {
        background-color: $cdr-color-background-primary;
      }

      &:after {
        background-color: $cdr-color-text-sale;
      }
    }

    &--sale-dark {
      color: $cdr-color-text-inverse;

      span {
        background-color: $cdr-color-background-message-sale;
      }

      &:after {
        background-color: $cdr-color-text-inverse;
      }
    }
  }
  </style>
